import { ViewId } from '@databases/types/database/view';
import * as Y from 'yjs';

import { BasicYArray, DisposableElement, WrappedYType } from './helpers/types';
import { YUniqueArray } from './helpers/y-unique-array';

export class YViewsArray implements DisposableElement, WrappedYType {
  private readonly views: YUniqueArray<string>;

  constructor(array: BasicYArray<string>) {
    this.views = new YUniqueArray(array);
    this.views.unwrap()!.observeDeep(this.onChange);
  }

  public toArray(): string[] {
    // TODO: Figure out a way to move this out of a getter
    this.onChange();
    return this.views.toArray();
  }

  public delete(...values: string[]): void {
    this.views.delete(...values);
  }

  addBefore(value: string[], before: string): void {
    this.views.addBefore(value, before);
  }

  addEnd(value: string): void {
    this.views.addEnd(value);
  }

  unwrap(): Y.AbstractType<string> | undefined {
    return this.views.unwrap();
  }

  private onChange = () => {
    if (!this.views.has(ViewId.ALL_ENTRIES)) {
      this.views.addStart(ViewId.ALL_ENTRIES);
    }
  };

  dispose(): void {
    this.views.unwrap()!.unobserveDeep(this.onChange);

    this.views.dispose();
  }
}
